<div id="popup-config" class="modal full" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true"
  data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" > Configurações </h5>
        <img data-dismiss="modal" class='bt-fechar' src="assets/imgs/icon_bt-limpar_header.svg">        
      </div>
      <div class="modal-body">

        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" data-toggle="tab" href="#config-feriado" role="tab">Tipos de Ocorrência</a>
          </li>
          <li class="nav-item">
            <a class="nav-link " data-toggle="tab" href="#motivo-finalizacao" role="tab">Motivos de Finalização de Ocorrências</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#tipo-recusa" role="tab">Motivos de Não Entregas</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#tipo-volto-depois" role="tab">Motivos de Volto Depois</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#filtro-avancados" role="tab">Filtro Avançado</a>
          </li>
        </ul> 

        <div class="tab-content">
          <div class="tab-pane conteudo " id="motivo-finalizacao" role="tabpanel">

            <div id="popup-status-finalizacao" class='container'>
              <div class="row">
                <div class="col-sm-4">
                  <h3>Cadastro Motivo de Finalização</h3>
                  <form id="CadastroFeriado">
                    <div>
                      <input type="text"  name="statusFinalizacao" [(ngModel)]="statusFinalizacao" placeholder="Digitar Status de Finalização">
                      <label for="" class="lblValidacao" *ngIf="msgValidacao != ''">{{ msgValidacao }}</label>
                    </div>
                    
                    <div>
                      <label class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" name="ckd_ativo" id="ckd_ativo" [value]="ckd_ativo" (click)="alteraStatus($event)" [checked]="ckd_ativo == 'S'">          
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-description"></span> Ativo
                      </label>
                    </div>
            
                    <div>
                      <button [disabled]="statusFinalizacao.length < 1" id="btn-cadastrar-status-finalizacao" class="btn btn-primary btn-block" name="btn-cadastrar-status-finalizacao" (click)="cadastrarStatusFinalizacao()">                      
                        {{modoEdicaoFinalizacao ? 'Editar' : 'Cadastrar'}}</button>
                    </div>
                  </form>
                </div>
                <div class="col-sm-8">
                  <h3> Motivos Cadastrados </h3>


                  <div class="mb-2">
                    <input 
                      type="text" 
                      [(ngModel)]="descricaoFiltroMotivo" 
                      placeholder="Filtrar por Descrição" 
                      class="form-control"                    
                    />
                  </div>

                  <div class="form-control">
                    <div class="table-height ">
                      <table class="table table-sm " style="height: 150px;">
                        <thead>
                          <tr>                            
                            <th class="p-0 pb-2 pt-2 pl-1 font-weight-bold"> Descrição </th>
                            <th class="p-0 pb-2 pt-2 pl-1 font-weight-bold"> Ativo </th>                              
                            <th class="p-0 pb-2 pt-2 pl-1 font-weight-bold text-center"> Ação </th>                         
                          </tr>        
                        </thead>
                        <tbody>        
                          <tr *ngFor="let finalizacao of popupConfigService.vetListaStatusFinalizacao | filterDescricao:descricaoFiltroMotivo ; let i=index">                    
                            <td > {{ finalizacao.Descricao }}</td>
                            <td > {{ finalizacao.Ativo }}</td>                         
                            
                            <td  class="text-center"> 
                              <button type="button" *ngIf="!modoEdicaoFinalizacao" class="btn btn-primary btn-sm " (click)="alteraModoEdicaoFinalizacao(finalizacao)" title="Editar">
                              <i class="fa fa-pencil"></i> Editar 
                              </button>
    
                            <button type="button" *ngIf="modoEdicaoFinalizacao && finalizacaoEdicaoAtual == finalizacao" class="btn btn-secondary btn-sm " (click)="cancelarEdicaoFinalizacao()" title="Cancelar">
                              <i class="fa fa-close"></i> Cancelar 
                            </button>
                            
                            </td>    
                          </tr>
                        </tbody>        
                      </table>
                    </div>    
                  </div>

                </div>
              </div>
            </div>

          </div>
          <div class="tab-pane conteudo active" id="config-feriado" role="tabpanel">
            <div class='container'>
              <div class="row">
                <div class="col-sm-4">
                  <h3> Adicionar Tipos de Ocorrência </h3> 
                  <form id="CadastroMotivo">

                    <input type="text"  name="descricaoMotivo" [(ngModel)]="descricaoMotivo"  placeholder="Descrição do Tipo de Ocorrência">
                    <label for="descricaoMotivo" class="validacao validacaoMotivo">{{ msgValidacaoDescMotivo }}</label>

                    <div style="margin-top: 2px;">
                      <label class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" name="ckd_tipoOc" id="ckd_tipoOc" [value]="ckd_tipoOc" (click)="alteraTipoOc($event)" [checked]="ckd_tipoOc == true">          
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-description"></span> Ativo
                      </label>
                    </div>
                    
                    <div>
                      <button style="margin-top: 10px;" [disabled]="descricaoMotivo.length < 1" class="btn btn-primary btn-block" (click)="cadastrarMotivo()"> {{ modoEdicaoMotivo? 'Editar' :  'Cadastrar'}} </button>
                    </div>
                  
                  </form>
                </div>
                <div class="col-sm-8">
                  <h3> Tipos de Ocorrência Cadastrados </h3>

                  <div class="mb-2">
                    <input 
                      type="text" 
                      [(ngModel)]="descricaoFiltroFinalizacao" 
                      placeholder="Filtrar por Descrição" 
                      class="form-control"                    
                    />
                  </div>

                  <div class="form-control">
                    <div class="table-height ">
                      <table class="table table-sm " style="height: 150px;">
                        <thead>
                          <tr>                            
                            <th class="p-0 pb-2 pt-2 pl-1 font-weight-bold"> Descrição </th>
                            <th class="p-0 pb-2 pt-2 pl-1 font-weight-bold"> Ativo </th>                              
                            <th class="p-0 pb-2 pt-2 pl-1 font-weight-bold text-center"> Ação </th>                         
                          </tr>        
                        </thead>
                        <tbody>        
                          <tr *ngFor="let motivo of listMotivos | filterDescricao:descricaoFiltroFinalizacao; let i=index">                    
                            <td > {{ motivo.Descricao }}</td>
                            <td > {{ motivo.Ativa }}</td>                         
                            
                            <td  class="text-center"> 
                              <button type="button" *ngIf="!modoEdicaoMotivo" class="btn btn-primary btn-sm " (click)="alteraModoEdicaoMotivo(motivo)" title="Editar">
                              <i class="fa fa-pencil"></i> Editar 
                              </button>
    
                            <button type="button" *ngIf="modoEdicaoMotivo && motivoEdicaoAtual == motivo" class="btn btn-secondary btn-sm " (click)="cancelarEdicaoMotivo()" title="Cancelar">
                              <i class="fa fa-close"></i> Cancelar 
                            </button>
                            
                            </td>    
                          </tr>
                        </tbody>        
                      </table>
                    </div>    
                  </div>

                </div>
              </div>
              </div>
            </div>

            <!-- Tipos de Recusas -->
            <div class="tab-pane conteudo " id="tipo-recusa" role="tabpanel">

              <div id="popup-status-finalizacao" class='container'>
                <div class="row">
                  <div class="col-sm-4">
                    <h3>Cadastro de Motivos de Não Entregas</h3>
                    <form id="CadastroFeriado">
                      <div>
                        <input type="text"  name="tipoRecusa" [(ngModel)]="tipoRecusa" placeholder="Digitar motivo de Não entrega">
                        <label for="" class="lblValidacao" *ngIf="msgValidacao != ''">{{ msgValidacao }}</label>
                      </div>
                      
                      <div>
                        <label class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" name="ckd_tipoRecusa" id="ckd_tipoRecusa" [value]="ckd_tipoRecusa" (click)="alteraTipoRecusa($event)" [checked]="ckd_tipoRecusa == true">          
                          <span class="custom-control-indicator"></span>
                          <span class="custom-control-description"></span> Ativo
                        </label>
                      </div>
              
                      <div>
                        <button id="btn-cadastrar-status-finalizacao" [disabled]="tipoRecusa.length < 1" class="btn btn-primary btn-block" name="btn-cadastrar-status-finalizacao" (click)="cadastrarTipoRecusa()">  
                        {{ modoEdicaoTipoRecusa? 'Editar': 'Cadastrar'}} 
       
                         </button>
                      </div>
                    </form>
                  </div>
                  <div class="col-sm-8">
                    <h3> Motivos de Não Entregas Cadastradas </h3>

                    <div class="mb-2">
                      <input 
                        type="text" 
                        [(ngModel)]="descricaoFiltroTipoRecusa" 
                        placeholder="Filtrar por Descrição" 
                        class="form-control"                    
                      />
                    </div>
  
                    <div class="form-control">
                      <div class="table-height ">
                        <table class="table table-sm " style="height: 150px;">
                          <thead>
                            <tr>                            
                              <th class="p-0 pb-2 pt-2 pl-1 font-weight-bold"> Descrição </th>
                              <th class="p-0 pb-2 pt-2 pl-1 font-weight-bold"> Ativo </th>                              
                              <th class="p-0 pb-2 pt-2 pl-1 font-weight-bold text-center"> Ação </th>                         
                            </tr>        
                          </thead>
                          <tbody>        
                            <tr *ngFor="let recusa of popupConfigService.vetListaTipoRecusa | filterDescricao:descricaoFiltroTipoRecusa ; let i=index">                    
                              <td > {{ recusa.Descricao }}</td>
                              <td > {{ recusa.Ativa }}</td>                         
                              
                              <td  class="text-center"> 
                                <button type="button" *ngIf="!modoEdicaoTipoRecusa" class="btn btn-primary btn-sm " (click)="alteraModoEdicaoTipoRecusa(recusa)" title="Editar">
                                <i class="fa fa-pencil"></i> Editar 
                                </button>
      
                              <button type="button" *ngIf="modoEdicaoTipoRecusa && tipoRecusaEdicaoAtual == recusa" class="btn btn-secondary btn-sm " (click)="cancelarEdicaoTipoRecusa()" title="Cancelar">
                                <i class="fa fa-close"></i> Cancelar 
                              </button>
                              
                              </td>    
                            </tr>
                          </tbody>        
                        </table>
                      </div>    
                    </div>

                  </div>
                </div>
              </div>
  
            </div>


             <!-- Tipos de Volto Depois -->
             <div class="tab-pane conteudo " id="tipo-volto-depois" role="tabpanel">

              <div id="popup-status-finalizacao" class='container'>
                <div class="row">
                  <div class="col-sm-4">
                    <h3>Cadastro de Motivos de Volto Depois</h3>
                    <form id="CadastroFeriado">
                      <div>
                        <input type="text"  name="tipoVoltoDepois" [(ngModel)]="tipoVoltoDepois" placeholder="Digitar motivo de Volto Depois">
                        <label for="" class="lblValidacao" *ngIf="msgValidacao != ''">{{ msgValidacao }}</label>
                      </div>
                      
                      <div>
                        <label class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" name="ckd_tipoVoltoDepois" id="ckd_tipoVoltoDepois" [value]="ckd_tipoVoltoDepois" (click)="alteraTipoVoltoDepois($event)" [checked]="ckd_tipoVoltoDepois == true">          
                          <span class="custom-control-indicator"></span>
                          <span class="custom-control-description"></span> Ativo
                        </label>
                      </div>
              
                      <div>
                        <button id="btn-cadastrar-status-finalizacao" [disabled]="tipoVoltoDepois.length < 1" class="btn btn-primary btn-block" name="btn-cadastrar-status-finalizacao" (click)="cadastrarTipoVoltoDepois()">  
                        {{ modoEdicaoVoltoDepois? 'Editar' : 'Cadastrar' }}
       
                         </button>
                      </div>
                    </form>
                  </div>
                  <div class="col-sm-8">
                    <h3> Motivos de Volto Depois </h3>

                    <div class="mb-2">
                      <input 
                        type="text" 
                        [(ngModel)]="descricaoFiltroVoltoDepois" 
                        placeholder="Filtrar por Descrição" 
                        class="form-control"                    
                      />
                    </div>
  
                    <div class="form-control">
                      <div class="table-height ">
                        <table class="table table-sm " style="height: 150px;">
                          <thead>
                            <tr>                            
                              <th class="p-0 pb-2 pt-2 pl-1 font-weight-bold"> Descrição </th>
                              <th class="p-0 pb-2 pt-2 pl-1 font-weight-bold"> Ativo </th>                              
                              <th class="p-0 pb-2 pt-2 pl-1 font-weight-bold text-center"> Ação </th>                         
                            </tr>        
                          </thead>
                          <tbody>        
                            <tr *ngFor="let voltoDepois of listVoltoDepois | filterDescricao:descricaoFiltroVoltoDepois ; let i=index">                    
                              <td > {{ voltoDepois.Descricao }}</td>
                              <td > {{ voltoDepois.Ativa }}</td>                         
                              
                              <td  class="text-center"> 
                                <button type="button" *ngIf="!modoEdicaoVoltoDepois" class="btn btn-primary btn-sm " (click)="alteraModoEdicaoVoltoDepois(voltoDepois)" title="Editar">
                                <i class="fa fa-pencil"></i> Editar 
                                </button>
      
                              <button type="button" *ngIf="modoEdicaoVoltoDepois && voltoDepoisEdicaoAtual == voltoDepois" class="btn btn-secondary btn-sm " (click)="cancelarEdicaoVoltoDepois()" title="Cancelar">
                                <i class="fa fa-close"></i> Cancelar 
                              </button>
                              
                              </td>    
                            </tr>
                          </tbody>        
                        </table>
                      </div>    
                    </div>
                  </div>
                </div>
              </div>
  
            </div>

            <!-- Filtro avançado -->
            <div class="tab-pane conteudo " id="filtro-avancados" role="tabpanel">
              
              <div id="popup-status-finalizacao" class='container'>
                <div class="row">
                  <div class="col-sm-3">

                    <div class="mt-3">
                      <label class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" name="ckdFiltroAvancado" id="ckdFiltroAvancado" [value]="ckbFiltroAvancado"  (click)="alteraConfFiltroAvancado()" [checked]="ckbFiltroAvancado == true">          
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-description filtro-avancado"> Ativar recurso</span>
                      </label>
                    </div>

        
                    <form id="CadastroFeriado" >    
                      <h3> {{ modoEdicao? 'Editar' : 'Cadastrar'}} e-mail do atendente</h3>          
                      <div>
                        <input type="text"  name="nomeAtendente" [(ngModel)]="nomeAtendente" placeholder="Digitar e-mail do usuário"  [disabled]="!ckbFiltroAvancado">
                        <label for="" class="lblValidacao" *ngIf="msgValidacao != ''">{{ msgValidacao }}</label>
                      </div>
                      
                       <h3>Motoristas</h3>   
                       <div class="d-flex">
                        <button class="btn btn-secondary mr-2 p-1 text-trans-none" (click)="marcarTodosMotor()">Marcar todos</button>
                        <button class="btn btn-secondary p-1 text-trans-none" (click)="desmarcarTodosMotor()">Desmarcar todos</button>
                      </div> 
                      <ul class="table-motoristas shadow-lg">
                        <li *ngFor="let motorista of motoristas">
                          <input type="checkbox" class="mr-2" [checked]="motorista.checked" [disabled]="!ckbFiltroAvancado" (change)="alterarCheckedMotor(motorista.CdMotor)">{{motorista.Nome}}
                        </li>
                      </ul>    
                      
                      <div *ngIf="ckbFiltroAvancado">
                        <label class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input"  name="ckd_confFiltroAtivo" id="ckd_confFiltroAtivo" [value]="ckd_confFiltroAtivo" (click)="alteraConfigFiltorAtivo()" [checked]="ckd_confFiltroAtivo == true">          
                          <span class="custom-control-indicator" ></span>
                          <span class="custom-control-description"></span> Ativo
                        </label>
                      </div>
                        
                      <div>
                        <button  [disabled]="nomeAtendente.length < 1 || !ckbFiltroAvancado" class="btn btn-primary btn-block"  (click)="cadastrarFiltroAvancado()">  
                        {{ modoEdicao? 'Editar': 'Cadastrar'}}                       
                        </button>                 
                      </div>
                    </form>
                  </div>
                  <div class="col-sm-9" *ngIf="ckbFiltroAvancado">
                    <h3> E-mail de Atendentes Cadastrados </h3>
                   <div class="table-filtro-avancado form-control">
                      <div *ngIf="!usuariosOcorrencia.length ;else tabelaUsuario">
                        <h4>Não há dados cadastrados.</h4>
                      </div>
                      <ng-template #tabelaUsuario>
                       <div  >
                        <table class="table table-sm ">
                          <thead>
                            <tr>                            
                              <th class="p-0 pb-2 pt-2 pl-1 font-weight-bold"> E-mail </th>
                              <th class="p-0 pb-2 pt-2 pl-1 font-weight-bold"> Ativo </th>                              
                              <th class="p-0 pb-2 pt-2 pl-1 font-weight-bold"> Motoristas</th>
                              <th class="p-0 pb-2 pt-2 pl-1 font-weight-bold"> Ação </th>                         
                            </tr>        
                          </thead>
                          <tbody>        
                            <tr *ngFor="let usuario of usuariosOcorrencia; let i=index">                       
                              <td > {{ usuario.Usuario }}</td>
                              <td > {{ usuario.Ativo? 'Sim' : 'Não' }}</td>   
                              <td class="linha-unica dropdown" id="dropdownMenuButton" [title]="usuario.motoristas | nomeMotorista"> {{ usuario.motoristas | nomeMotorista }}      </td>  
                              
                            
                              <td  > 
                                <button type="button" *ngIf="!modoEdicao" class="btn btn-primary btn-sm" (click)="alteraModoEdicao(usuario)" title="Editar">
                                <i class="fa fa-pencil"></i> Editar 
                                </button>

                              <button type="button" *ngIf="modoEdicao && usuarioEdicaoAtual == usuario" class="btn btn-secondary btn-sm" (click)="cancelarEdicao(usuario)" title="Cancelar">
                                <i class="fa fa-close"></i> Cancelar 
                              </button>
                              
                              </td>    
                            </tr>
                          </tbody>        
                        </table>
                      </div>
                      </ng-template>
                   </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>